import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'pm-ui-confirm-alert',
  templateUrl: './confirm-alert.component.html',
  styleUrls: ['./confirm-alert.component.scss']
})
export class ConfirmAlertComponent {
  readonly message: string = 'Do you really want to continue?';

  constructor(private bsModalRef: BsModalRef) { }

  onConfirm = (isConfirmed: boolean): void => {
    if (this.bsModalRef?.content.callback)
      this.bsModalRef?.content.callback(isConfirmed);

    this.onClose();
  }

  onClose = (): void => {
    this.bsModalRef?.hide();
  }
}
